import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import * as firebase from "firebase";
import App from './App.vue'
import router from "./routes/index";
import store from "./store";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxLfgFpuDMb-9IoQjhvC0z4D8vzgPJHaE",
  authDomain: "marketing-assessment-tool.firebaseapp.com",
  databaseURL: "https://marketing-assessment-tool.firebaseio.com",
  projectId: "marketing-assessment-tool",
  storageBucket: "marketing-assessment-tool.appspot.com",
  messagingSenderId: "1039554806809",
  appId: "1:1039554806809:web:69505d49d8dd55f4c29688",
  measurementId: "G-NDDE5BSWHN"
};

firebase.default.initializeApp(firebaseConfig);

firebase.default.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

Vue.use(BootstrapVue)
Vue.use(VueFormulate)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
